import React, {useState} from 'react'
import {Box , Grid , Typography , Divider , TextField} from "@mui/material"
import CustomSwitch from '../../../shared/CustomOnOffSwitch'
import PrimaryButton from '../../../shared/PrimaryButton'
import CustomerFile from '../CustomerFile/CustomerFile'
import CustomButton from '../../../shared/CustomButton'
import { useDispatch } from 'react-redux'
import { customerFileUpload } from '../../state/actions'
const RightSideSetting = ({formik , setTouched , error , success , configurationData , Groups , touched}) => {
  const handleChange = (e) => {
    setTouched(true);
    console.log(e.target.value)
    formik.handleChange(e);
  };

  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [openTable,setOpenTable] = useState(false)
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (event,reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false);
  };
  const [fileProps,setFileProps]=useState({})
 


  const handleChangeFile = (event) => {
    
    let fileTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ]; 
    if (event.target.files.length > 0) {
      const customerFileBody = new FormData();
      const file = event.target.files[0];
 
      const moduleFile = "customer_batch_entry"
      if (!fileTypes.includes(file.type)) {
        error("Only EXCEL Docs Allowed!");
        return;
      }
      setFileProps({
        size: `${(file.size / 1024).toFixed(2)} KB`,
        name: file.name,
      });
      customerFileBody.append("file",file);
      customerFileBody.append("module",moduleFile);
      handleClickOpen()
      dispatch(customerFileUpload(customerFileBody,success,error))
      event.target.value = "";
  }
}
  return (
<div>

<section style={{marginBottom:"20px"}}>
<Box 
    sx={{
     backgroundColor: "#fff",
     borderRadius:"6px",
     boxShadow: "0 3px 4px -3px rgba(0,0,0,0.1)",
     border: "1px solid #E7E9EF"

   }}>

<Grid  container
 justifyContent="space-between"
alignItems={"center"}
 sx={{ marginBottom: "10px" , p:3 }}>
<Typography 
  sx={{
   color: "#050D2E",
   fontSize: ".875rem",
   fontWeight: "bold",
   lineHeight: "21px",
   marginBottom: "5px",
 }}
>
Client ID length
</Typography>


 <TextField
 type={"number"}
 sx={{
   width: "60px",
   height: "36px",
   "& .MuiInputBase-root": { height: "36px" },
   "& .MuiOutlinedInput": { height: "36px" },
   
 }}
 name="clientId"
            value={formik.values.clientId}
            onChange={handleChange}
            error={
              formik.touched.clientId && Boolean(formik.errors.clientId)
            }
            helperText={formik.touched.clientId && formik.errors.clientId}
 />


</Grid>
<Divider sx={{ ml:3 , mr:3}} />

<Grid  container
 justifyContent="space-between"
alignItems={"center"}
 sx={{ marginBottom: "10px" , p:3 }}>
<Typography 
  sx={{
   color: "#050D2E",
   fontSize: "14px",
   fontWeight: "bold",
   lineHeight: "21px",
   marginBottom: "5px",
   width:"80%"
 }}
>
Send automatic warning mail to client before expire
</Typography>


 <TextField
 type={"number"}
 sx={{
   width: "60px",
   height: "36px",
   "& .MuiInputBase-root": { height: "36px" },
   "& .MuiOutlinedInput": { height: "36px" },
   
 }}
 name="warningMail"
            value={formik.values.warningMail}
            onChange={handleChange}
            error={
              formik.touched.warningMail && Boolean(formik.errors.warningMail)
            }
            helperText={formik.touched.warningMail && formik.errors.warningMail}
 />


</Grid>


<Divider sx={{ ml:3 , mr:3}} />

<Grid  container
 justifyContent="space-between"
alignItems={"center"}
 sx={{ marginBottom: "10px" , p:3 }}>
<Typography 
  sx={{
   color: "#050D2E",
   fontSize: "14px",
   fontWeight: "bold",
   lineHeight: "21px",
   marginBottom: "5px",
   width:"68%"
 }}
>
Add WaterMark for protected client
</Typography>


<CustomSwitch
name="waterMark"
id="waterMark"
onChange={handleChange}
checked={formik.values.waterMark}
value={formik.values.waterMark}
/> 
</Grid>

<Grid 
textAlign={"end"}
sx={{p:2 }}
>

<CustomButton text="Save Changes" type="update" disabled={!touched} action={formik.handleSubmit} />

</Grid>

 </Box>
</section>

<section>
    
<Box 
sx={{
 backgroundColor: "#fff",
 borderRadius:"6px",
 boxShadow: "0 3px 4px -3px rgba(0,0,0,0.1)",
 border: "1px solid #E7E9EF",
 padding:"20px"

}}>

<Grid  
container
sx={{marginBottom:"20px"}}
>
<Typography 
sx={{
color: "#050D2E",
fontSize: ".875rem",
fontWeight: "bold",
lineHeight: "21px",
}}
>
Directory
</Typography>
</Grid>


<Grid  container
justifyContent="space-between"
alignItems={"end"}
sx={{marginBottom:"30px"}}
>

<div>
<Typography 
sx={{
color: "#050D2E",
fontSize: ".875rem",
fontWeight: "bold",
lineHeight: "21px",
marginBottom:"10px"
}}
>
Customer file
</Typography>
<TextField
sx={{
width: "230px",
height: "36px",
"& .MuiInputBase-root": { height: "36px" },
"& .MuiOutlinedInput": { height: "36px" },
}}
value={fileProps.name}
aria-readonly
/>
</div>
{open && 
 <CustomerFile 
 handleClickOpen={handleClickOpen} 
 handleClose={handleClose}
  setOpenTable={setOpenTable}
   openTable={openTable}
   open={open}
   setOpen={setOpen}
   fileProps={fileProps}
   success={success}
   error={error}
   configurationData={configurationData}
   Groups={Groups}
   />}
<PrimaryButton component="label">
   Browse Files  <input hidden name='customerFile'   onChange={handleChangeFile}  accept=".xlsx" type="file" />
</PrimaryButton>

</Grid>

<Grid  
justifyContent="space-between"
alignItems={"end"}
container
sx={{marginBottom:"30px"}}
>

<div>
<Typography 
sx={{
color: "#050D2E",
fontSize: ".875rem",
fontWeight: "bold",
lineHeight: "21px",
marginBottom:"10px"
}}
>
Branch file
</Typography>
<TextField
sx={{
width: "230px",
height: "36px",
"& .MuiInputBase-root": { height: "36px" },
"& .MuiOutlinedInput": { height: "36px" },

}}
value={formik.values.branchFile}
/>
</div>

<PrimaryButton component="label">
Browse Files  <input hidden name='branchFile'  onChange={handleChange}  type="file" />
</PrimaryButton>

</Grid>


</Box>

</section>




</div>
  )
}

export default RightSideSetting